import styled from 'styled-components';

interface IProps {
  isCollaboratorsExists?: boolean;
  isClickable?: boolean;
  mb?: number;
  ml?: number;
  mr?: number;
  pr?: number;
  pl?: number;
  fs?: number;
  color?: string;
  isEventHomeTab?: boolean;
  img?: string;
}

export const EventDetailsBlock = styled.div<IProps>`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 16px;
  box-sizing: border-box;
  border-right: 1px solid ${(props) => props.theme.colors.neutral.n2};
  border-left: 1px solid ${(props) => props.theme.colors.neutral.n2};

  ${({ isCollaboratorsExists }) => {
    if (isCollaboratorsExists) {
      return `border-bottom: 1px solid ${(props) =>
        props.theme.colors.neutral.n4}`;
    }

    return `border-bottom: 1px solid ${(props) =>
      props.theme.colors.neutral.n2};
        border-bottom-right-radius: 8px; border-bottom-left-radius: 8px;`;
  }};
`;

export const ClickableArea = styled.div<IProps>`
  cursor: ${({ isClickable }) => (isClickable ? 'pointer' : 'auto')};
`;

export const EventPeriod = styled.div`
  display: flex;
  align-items: center;

  p {
    margin-left: 8px;
    font-size: 13px;
    line-height: 100%;
    color: ${(props) => props.theme.colors.neutral.n8};
  }
`;

export const EventNameText = styled.p`
  font-size: 18px;
  line-height: 100%;
  font-weight: 600;
  color: ${(props) => props.theme.colors.black};
  margin: 16px 0;
`;

export const BlockGeolocation = styled.div<IProps>`
  display: flex;
  align-items: center;
  margin-bottom: ${({ mb }) => (mb ? `${mb}px` : '0')};
  padding-right: ${({ pr }) => (pr ? `${pr}px` : '0')};
  padding-left: ${({ pl }) => (pl ? `${pl}px` : '0')};
  cursor: pointer;

  p {
    width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    font-size: ${({ fs }) => (fs ? `${fs}px` : '13px')};
    line-height: 123%;
    color: ${({ color, theme }) => color || theme.colors.blue};
    letter-spacing: 0.02em;
    margin-left: ${({ ml }) => (ml ? `${ml}px` : '0')};
    opacity: 0.9;
  }
`;

export const EventCreatorWrap = styled.div<IProps>`
  display: flex;
  align-items: center;
  margin-bottom: ${({ isEventHomeTab }) => (isEventHomeTab ? '0' : '16px')};
  cursor: pointer;
  align-self: flex-start;
`;

export const EventCreatorImageWrap = styled.span<IProps>`
  display: block;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  overflow: hidden;
  background: url(${({ img }) => img}) no-repeat;
  background-size: cover;
  background-position: center;
  margin-right: 8px;
`;

export const EventCreatorName = styled.p<IProps>`
  font-size: 13px;
  line-height: 100%;
  letter-spacing: 0.02em;
  color: ${({ color, theme }) => color || theme.colors.neutral.n8};
  margin-left: ${({ ml }) => (ml ? `${ml}px` : '0')};
`;

export const UserIconWrap = styled.div<IProps>`
  width: 16px;
  height: 16px;
  margin-left: 8px;
  margin-right: ${({ mr }) => (mr ? `${mr}px` : '0')};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const EventAttendingWrap = styled(EventCreatorWrap)`
  cursor: auto;
`;

export const EventAttendingItem = styled.div<IProps>`
  cursor: ${({ isClickable }) => (isClickable ? 'pointer' : 'auto')};
  margin-right: ${({ mr }) => (mr ? `${mr}px` : '0')};
  margin-left: ${({ ml }) => (ml ? `${ml}px` : '0')};
  line-height: 100%;
`;

export const EventAttendingText = styled(EventCreatorName)`
  display: inline-block;
`;

export const EventButtons = styled.div<IProps>`
  display: flex;
  width: 100%;

  button {
    margin-right: 16px;

    :last-of-type {
      margin-right: 0;
    }
  }
`;

export const CanceledEventText = styled.p`
  width: 100%;
  height: 40px;
  margin-right: 15px;
  background-color: ${(props) => props.theme.colors.neutral.n0};
  font-size: 20px;
  line-height: 100%;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  font-weight: 500;
  color: ${(props) => props.theme.colors.black};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const MessageButtonWrap = styled.div`
  width: 40px;
  padding: 0 !important;
  margin-left: 16px;

  div {
    text-align: center;
    display: flex;
    flex-direction: column;
    padding: 0;
    width: 40px;
  }
`;
export const LabelWrap = styled.span`
  display: flex;
  align-items: center;
  padding-left: 4px;
  & > svg {
    height: 20px;
    width: 20px;
    margin-right: 5px;
  }
`;
export const LabelName = styled.span``;